export default {
  personalInformation (state) {
    return state.profile
  }
}
